import { put, takeLatest } from 'redux-saga/effects';
import { SpaceAPI } from 'api/space/space';
import { StoreActionProps } from 'data/core';
import { deleteSpaceSagaAction, DeleteSpacePayload } from '../actions';
import { deleteStart, deleteSuccess, deleteFailure } from '../index';

function* deleteSpaceSaga(action: StoreActionProps<DeleteSpacePayload>) {
  const { payload } = action;
  const { spaceId, history, redirectURL } = payload;

  try {
    yield put(deleteStart(spaceId));
    yield SpaceAPI.deleteSpace(spaceId);

    if (redirectURL.length) {
      history.push(redirectURL);
    }

    yield put(deleteSuccess(spaceId));
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
  } catch (error) {
    yield put(deleteFailure(''));
  }
}

export function* watchDeleteSpaceSaga(): Generator {
  yield takeLatest(deleteSpaceSagaAction.type, deleteSpaceSaga);
}
